import { tracker } from '@openreplay/tracker';

function safeCall(fn: () => void, method: string) {
  try {
    fn();
  } catch (e) {
    console.error(`[analytics] ${method} failed`, e);
  }
}

/**
 * Analytics service - OpenReplay wrapper
 * Used for operational events, debugging, and session recording
 */
export const analytics = {
  identify(userId: string) {
    safeCall(() => tracker.setUserID(userId), 'identify');
  },

  event(name: string, payload?: Record<string, unknown>, isError = false) {
    safeCall(() => tracker.event(name, payload, isError), 'event');
  },
};
